'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './voting-edit.routes';

export class VotingEditComponent {
  constructor(VotingsService, Auth, $state, dialogs, $stateParams, $uibModal, $location, BallotsService, User,
              SettingsService, PropertyService, VoterGroupsService, HistoryService, ClosingSnapshotsService,
              DTOptionsBuilder, $timeout, DTColumnBuilder, $sce, $scope) {
    'ngInject';

    this.DTOptionsBuilder = DTOptionsBuilder;
    this.DTColumnBuilder = DTColumnBuilder;

    this.VotingsService = VotingsService;
    this.BallotsService = BallotsService;
    this.VoterGroupsService = VoterGroupsService;
    this.HistoryService = HistoryService;
    this.ClosingSnapshotsService = ClosingSnapshotsService;
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$location = $location;
    this.$timeout = $timeout;
    this.$sce = $sce;
    this.$scope = $scope;
    this.voteId = $stateParams.id;
    this.currentState = "draft";

    this.allowedVoterProperties = [];
    this.allowedVoterContacts = [];

    this.faieldHtml = "";

    this.sortableOptions = {
      handle: '.handle'
    };

    this.states = [{
      name: 'Draft',
      state: 'draft'
    }, {
      name: 'Open',
      state: 'open'
    }];

    if (this.voteId) { // cannot select close on create
      this.states.push({
        name: 'Closed',
        state: 'closed'
      })
    }

    this.toolbarDefinition = [
      ["bold","italics","underline","strikeThrough"],
      ["h3","h4","h5"],
      ["p","pre","quote","clear"],
      ["ul","ol"],
      ["justifyLeft","justifyCenter","justifyRight","justifyFull"],
      ["indent","outdent"],
      ["undo","redo"],
      ["insertImage", "insertLink"]
    ];

    SettingsService.getByName({name: 'config.app'}, settings => {
      let ssDT = settings.data.serverSideDT || {};
      this.serverSideDT = ssDT && ssDT.voterGroups && ssDT.voterGroups.enabled;
      this.serverSideUseBldgUnit = ssDT && ssDT.properties && ssDT.properties.useBldgUnit;

      SettingsService.getByName({name: 'client'}, settings => {
        this.useSuite = settings.data.useSuite;

        this.weightVisible = settings.data.weightVisible;
        this.hasBuildingNo = settings.data.buildingNoVisible;

        this.dtOptions = DTOptionsBuilder.newOptions()
          .withOption('order', (this.hasBuildingNo) ? [[0, 'asc'], [1, 'asc']] : [0, 'asc']);

        this.selectedVoterGroup = null;

        let VG_QUERY_METHOD = (this.useSuite) ? "querySuite" : "query";

        VoterGroupsService[VG_QUERY_METHOD](data => {
          this.voterGroups = data.map(vg => {
            vg.type = (vg.type == 'properties') ? 'Properties' : 'Contacts';
            return vg
          });

          let that = this;

          this.defaultOrder = (this.hasBuildingNo) ? [[0, 'asc'], [1, 'asc']] : [0, 'asc'];
          if (this.serverSideUseBldgUnit)
            this.defaultOrder = [0, 'asc'];

          this.dtColumns = [];

          if (this.serverSideUseBldgUnit)
            this.dtColumns.push(DTColumnBuilder.newColumn("customFields.buildingUnit").withTitle('Bldg-Unit').withOption('width', '3%'));
          else if (this.hasBuildingNo) {
            this.dtColumns.push(DTColumnBuilder.newColumn("buildingNo").withTitle('Bldg#').withOption('width', '3%'));
            this.dtColumns.push(DTColumnBuilder.newColumn("lotNo").withTitle('Lot#').withOption('width', '3%'));
          } else {
            this.dtColumns.push(DTColumnBuilder.newColumn("lotNo").withTitle('Lot#').withOption('width', '3%'));
          }

          this.dtColumns.push(DTColumnBuilder.newColumn("address").withTitle('Address').withOption('width', '20%'));
          this.dtColumns.push(DTColumnBuilder.newColumn("primaryOwner").withTitle('Primary Owner').withOption('width', '15%'));
          this.dtColumns.push(DTColumnBuilder.newColumn("voter").withTitle('Voter').withOption('width', '15%'));


          this.dtOptionsSS = this.DTOptionsBuilder.newOptions()
            //.withOption('dom', 'lBfrtip')
            .withOption('serverSide', true)
            //.withOption('processing', true)
            //.withDataProp('data')
            //.withOption('stateSave', true)
            //.withOption('stateSaveCallback', DTState.save())
            //.withOption('stateLoadCallback', DTState.restore())
            .withOption('pagingType', 'full_numbers')
            .withOption('order', this.defaultOrder)
            .withOption('pageLength', 10)
            .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
            //.withOption('columns', [{ data: '_id' }, { data: 'firstName' }, { data: 'lastName' }])
            .withOption('ajax', (params, cb) => {

              if (!this.selectedVoterGroup || !this.selectedVoterGroup.type == 'Properties')
                return;

              if (params.search) {
                //params.search.fields = ["properties.buildingNo", "properties.lotNo", "properties.address.street", "properties.customFields.buildingUnit", "properties.eVoting.voter.firstName", "properties.eVoting.voter.lastName"];
                params.search.fields = ["buildingNo", "lotNo", "address.street", "customFields.buildingUnit"];
              }

              that.VoterGroupsService.getWithDataSS({id: that.vote.voterGroup}, params, result => {

                that.allowedVoterPropertiesSS = result.data;

                cb({
                  recordsTotal: result.recordsTotal,
                  recordsFiltered: result.recordsFiltered,
                  data: []
                })
              })
            });

          Auth.getCurrentUser(user => {
            this.userId = user._id;
            this.vote = {
              period: {},
              state: 'draft',
              meta: {
                creationUser: user._id
              }
            };

            if (this.voteId) {
              this.VotingsService.get({id: this.voteId}, vote => {
                this.vote = vote;
                this.currentState = vote.state;

                if (this.vote.voterGroup && this.vote.voterGroup._id) {
                  this.vote.voterGroup = this.vote.voterGroup._id;
                }

                if (this.vote.date)
                  this.vote.date = new Date(this.vote.date);

                if (this.vote.period.from)
                  this.vote.period.from = new Date(this.vote.period.from);
                if (this.vote.period.till)
                  this.vote.period.till = new Date(this.vote.period.till);

                if (this.vote.optInDeadline)
                  this.vote.optInDeadline = new Date(this.vote.optInDeadline);
                if (this.vote.optOutDeadline)
                  this.vote.optOutDeadline = new Date(this.vote.optOutDeadline);

                this.voterGroupChange();

                //this.loadForm();
              }, _ => console.log("Could not load voting from server"));
            } else {
              //this.loadForm();
            }
          });
        });
      });
    });
  }

  editBallot(ballot) {
    this.$location.url("/voting/edit/" + this.voteId + "/ballot/edit/" + ballot._id);
  }

  validationFailed() {
    let failed = false;
    let reasons = [];

    this.failedHtml = "";

   if (!this.vote.name) {
     reasons.push("Name of Voting Event");
     failed = true;
   }

   if (!this.vote.date) {
     reasons.push("Event Date");
     failed = true;
   }

   if (!this.vote.voterGroup){
     reasons.push("Voter Group");
     failed = true;
   }

   if (!this.vote.period || !this.vote.period.from){
     reasons.push("Start of E-Voting Period");
     failed = true;
   }

   if (!this.vote.period || !this.vote.period.till){
     reasons.push("End of Voting Period");
     failed = true;
   }

   if (!this.vote.optInDeadline){
     reasons.push("Opt-In Deadline");
     failed = true;
   }

   if (!this.vote.optOutDeadline){
     reasons.push("Opt-Out Deadline");
     failed = true;
   }

   if (failed) {
     let html = "Please enter all <b>required fields</b>: <ul style='padding-top:8px'>";
     reasons.forEach(reason => html += "<li>" + reason + "</li>");
     html += "</ul>";

     this.failedHtml = this.$sce.trustAsHtml(html);
   }

    return failed;
  }

  getPrimaryOwner(contacts) {
    if (!contacts || !contacts.length)
      return "-";

    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary)
      return "-";

    return this.getComposedName(primary.contact);
  }

  getPrimaryOwnerId(contacts) {
    let primary = contacts.find(contact => contact.type == 'primary-owner');

    if (!primary) // No Primary Owner
      return 0;
    else if (!primary.contact || !primary.contact._id) // Contact for Primary Owner deleted
      return -1;
    else
      return primary.contact._id;
  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "") {
        composedName += contact.company;
      } else {
        composedName += "<br/>" + contact.company;
      }
    }

    return composedName;
  }

  voterGroupChange() {
    this.dataInitComplete = false;
    this.selectedVoterGroup = this.voterGroups.find(vg => vg._id == this.vote.voterGroup);

    this.allowedVoterProperties.splice(0, this.allowedVoterProperties.length);
    this.allowedVoterContacts.splice(0, this.allowedVoterContacts.length);

    if (!this.selectedVoterGroup)
      return;

    if (this.serverSideDT) {
      this.$timeout(_=> { $('#dtAllowedPropertiesSS').DataTable().ajax.reload(); }, 100);
    }

    let VG_DATA_METHOD = (this.useSuite) ? "getWithDataSuite" : "getWithData";
    this.VoterGroupsService[VG_DATA_METHOD]({id: this.selectedVoterGroup._id}, vg => {
      if (this.selectedVoterGroup.type == 'Properties') {
        this.allowedVoterProperties.push(... vg.properties);
      } else {
        this.allowedVoterContacts.push(... vg.contacts);
      }

      this.dataInitComplete = true;
    });
  }

  createBallot() {
    this.$location.url("/voting/edit/"+this.voteId+"/ballot/edit/");
  }

  remove(voter) {
    this.vote.voters = this.vote.voters.filter(v => v.voter !== voter.voter);
  }

  deleteBallot(ballot) {
    var that = this;

    var ballotText = "<br/><br/><b>" + ballot.name + "</b><br/><p>" + ballot.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Ballot?", "Do you really want to delete the ballot?" + ballotText);
    dlg.result.then(() => {
      // OK delete it
      that.BallotsService.delete({id: ballot._id},
        () => {
          that.vote.ballots = that.vote.ballots.filter(function( obj ) {
            return obj._id !== ballot._id;
          });
        },
        err => {
          alert("Could not delete ballot");
        });
    }, () => {
      // Cancel
    });
  }

  openVoterSelectionModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'voterLookup',
      size: 'lg',
      resolve: {
        config: function() {
          return {}
        }
      }
    });

    modalInstance.result.then(
      function (voters) {

        let newVoters = voters.map(voter => {
          return {
            voter: voter.contact._id,
            property: voter.property._id
          }
        });

        newVoters.forEach(newVoter => that.vote.voters.push(newVoter))
      },
      function () { /* cancel */ }
    );

  }

  loadForm() {
    this.schema = {
      type: "object",
      properties: {
        name: {
          type: "string",
          title: "Name of the Voting Event"
        },
        description: {
          type: "string",
          title: 'Description of the Voting Event'
        },
        location: {
          type: "string",
          title: 'Voting Event Location'
        },
        date: {
          "title": "Event Date",
          type: "string",
          format: "date",
          "x-schema-form": {
            "type": "datepicker"
          }
        },
        period: {
          "title": "Voting Period & Opt-In/Out Deadlines",
          "type": "object",
          "properties": {
            "from": {
              "title": "Start of Online Voting Period",
              type: "string",
              format: "date",
              "x-schema-form": {
                "type": "datepicker"
              }
            },
            "till": {
              "title": "End of Online Voting Period",
              type: "string",
              format: "date",
              "x-schema-form": {
                "type": "datepicker"
              }
            }
          }
        },
        optInDeadline: {
          "title": "Opt-In Deadline",
          type: "string",
          format: "date",
          "x-schema-form": {
            "type": "datepicker"
          }
        },
        optOutDeadline: {
          "title": "Opt-Out Deadline",
          type: "string",
          format: "date",
          "x-schema-form": {
            "type": "datepicker"
          }
        },
        defaultProxy: {
          "title": "Default Proxy",
          "type": "object",
          "properties": {
            enabled: {
              "title": "Default Proxy Allowed",
              "type": "boolean"
            },
            name: {
              "title": "Default Proxy Name",
              "type": "string",
              "x-schema-form": {
                "condition": "model.defaultProxy.enabled"
              }
            }
          }
        }
      }
    };

    this.form=["*"]

    /*
    this.form = [
      {
        "type": "fieldset",
        "title": "General",
        "items": [
          "name",
          "description"
        ]
      },
      {
        "type": "fieldset",
        "title": "Period",
        "items": [
          "period.from",
          "period.till"
        ]
      },
      {
        "type": "fieldset",
        "title": "General Proxy",
        "items": [
          "generalProxy.enabled",
          {
            "type": "conditional",
            "condition": "model.generalProxy.enabled",
            "items": [
              {
                "key": "generalProxy.name",
                "placeholder": "General Proxy Name"
              }
            ]
          },
        ]
      }

    ];*/
  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      let action = (this.voteId) ? "changed" : "created";

      var onSuccess = () => {

        if (this.voteId && this.vote.state != this.currentState) {
          this.HistoryService.save({
            entityId: this.voteId,
            entityType: 'voting',
            action: "The state has changed from '" + this.currentState + "' to '" + this.vote.state + "'" ,
            actionType: "stateChanged",
            meta: {
              creationUser: this.userId
            }
          });
        }

        var dlg = this.dialogs.notify("Success", "The voting has been "+action+" successfully");
        dlg.result.then(() => {
          that.$state.go("voting-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      let contactKeep = ["_id", "firstName", "middleName", "lastName", "company", "email"];
      let propertiesKeep = ["_id", "lotNo", "buildingNo", "address", "eVoting", "contacts"];

      let pruneContact = contact => {

        let o = angular.copy(contact);

        for (let field in o) {
        if (!contactKeep.includes(field))
          delete o[field];
      }

      return o;
    };

      let pruneProperty = ppty => {

        let o = angular.copy(ppty);

        for (let field in o) {
          if (!propertiesKeep.includes(field))
            delete o[field];
        }

        if (o.eVoting && o.eVoting.voter) {
          o.eVoting.voter = pruneContact(o.eVoting.voter);
        }

        if (o.contacts && o.contacts.length) {
          let relevantContacts = o.contacts.filter(c => c.type == 'primary-owner' || c.type == 'owner');

          for (let c of relevantContacts) {
            c.contact = pruneContact(c.contact);
          }

         o.contacts = relevantContacts;
        }

        return o;
      };

      if (this.voteId) {

        if (this.vote.state == 'closed' && this.currentState != 'closed') {

          let data = (this.selectedVoterGroup.type == 'Properties')
            ? this.allowedVoterProperties.map(ppty => pruneProperty(ppty))
            : this.allowedVoterContacts.map(contact => pruneContact(contact));

          this.ClosingSnapshotsService.save({
            name: this.selectedVoterGroup.name,
            description: this.selectedVoterGroup.description + " (Closing Snapshot as of "+ moment().format('LLLL') +")",
            data: data,
            type: (this.selectedVoterGroup.type == 'Properties') ? 'properties' : 'contacts',
            voting: this.voteId,
            meta: {
              clientDate: new Date(),
              creationUser: this.userId,
              active: true
            }
          }, closingSnapshot => {
            this.vote.closingSnapshot = closingSnapshot._id;
            this.VotingsService.update({id: this.vote._id}, this.vote, onSuccess, onError);
          });

        } else if (this.vote.state != 'closed' && this.currentState == 'closed') {
          this.vote.closingSnapshot = undefined;
          this.VotingsService.update({id: this.vote._id}, this.vote, onSuccess, onError);
        } else {
          this.VotingsService.update({id: this.vote._id}, this.vote, onSuccess, onError);
        }

      } else {
        this.VotingsService.save(this.vote, onSuccess, onError);
      }

    }
  }
}

export default angular.module('conduu.votingEdit', [uiRouter])
  .config(routes)
  .component('votingEdit', {
    template: require('./voting-edit.html'),
    controller: VotingEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/voting/voting-edit/voting-edit.component.js